import { AbilityBuilder, Ability } from "@casl/ability";
import { ROLE_ADMIN, ROLE_OWNER, ROLE_SUPPORT, ROLE_BASIC } from "@/constant";

import store from "./store";

const getAbilities = () => {
  const { can, build, rules } = new AbilityBuilder(Ability);
  // This constant needs null check
  const userPermissions = store.getters["getActiveOrganization"]?.organizationPermissions ?? [];
  const userRoles = store.getters["getCurrentUser"].roles ?? [];

  // Convert objects values to array
  const organizationRoles = userPermissions.map(a => a.name);
  // Use standard words in can function description
  // First word should always be [create, read, update, delete]
  // Second word should be as concise as possible

  if (organizationRoles.includes(ROLE_OWNER.value)) {
    // Transfer ownership
    can("update", "organization ownership");
  }

  if (organizationRoles.includes(ROLE_OWNER.value) || organizationRoles.includes(ROLE_ADMIN.value)) {
    // Organization resource options 🔑
    // Update the organization name
    can("update", "organization name");

    // Invite user to the organization
    can("update", "organization user list");

    // Change user roles (self or others)
    can("update", "user role permissions");

    // See the lists of other people domains
    can("read", "other user domains");

    // Delete user domains (only for others)
    can("delete", "assigned domains");

    // Add user domains (only for others)
    can("update", "assigned domains");

    // Edit or read admin domains (only for other admins/owners)
    can("read or edit", "admin domains");

    // Create A/B tests
    can("create", "ab_test");

    // Update A/B tests
    can("update", "ab_test");

    // View parameter
    can("update", "domains parameter");

    // View comments widget
    can("view", "ab_test form source");
  }

  if (process.env.VUE_APP_INULTI_BUILD === "true" && !organizationRoles.includes(ROLE_BASIC.value)) {
    // View AI tools
    can("view", "ai_tools");
    // View/use multi-step-quiz shortcodes with loaders
    can("view", "multi-step-quiz shortcodes with loaders");

    //All shortcodes (Design Elements)
    can("view", "all shortcodes");

    //View homepage column in domains table
    can("view", "homepage column");

    //View suspension/Namecheap columns in domains table and the Suspension tab in domain settings
    can("view", "domain suspension columns");

    //View page categories tab in domain settings
    can("view", "page categories");

    //View type column in pages table
    can("view", "type column");

    //View type filter in pages table
    can("view", "type filter");

    //View email service in domain settings
    can("view", "email service");

    //View enable homepage in domain settings
    can("view", "enable homepage");

    //View homepage categories in domain settings
    can("view", "homepage categories");

    //View adsense in domain settings
    can("view", "adsense");

    //View page type in page form
    can("view", "page type");

    //View blog desktop layouts in header from
    can("view", "header blog desktop layouts");

    //View footer desktop layouts
    can("view", "footer desktop layouts");

    //View page category as an option in menu items
    can("view", "menu item page category");

    //View sidebar layout column
    can("view", "sidebar layout column");

    //Create footers of type "audio_forms"
    can("create", "audio forms footer");

    //View original domain connect (no external registrars)
    can("view", "original domain connect");

    //Ignore paywall limits
    can("ignore", "paywall limits");

    //Upload media object to inulti server instead of bunny cdn
    can("upload", "media object to inulti server");

    //Use inulti clarity script
    can("use", "inulti clarity script");

    //View alternative content in page form
    can("view", "alternative content");

    //View siterunner branding
    can("view", "siterunner branding");

    //View ringba parameters
    can("view", "ringba parameters");

    //View page background color and image
    can("view", "page background options");

    //View ringba ringba User tag (campaign angle)
    can("view", "ringba user tag");

    //View live chat ringba parameters
    can("view", "live chat ringba parameters");

    //View google analytics tracking input
    can("view", "google analytics tracking");

    //View session count
    can("view", "session count");

    //View application data
    can("view", "application data");

    //View advanced content search
    can("view", "advanced content search");

    //View pre-headline in page form field
    can("view", "pre-headline field");

    // Can delete default domain
    can("delete", "default domain");

    //View A/B testing redirect type select
    can("view", "A/B redirect type");

    //View calendars
    can("view", "calendars");

    //View form setup resource
    can("view", "form setup");

    //View phone numbers
    can("view", "phone numbers");

    //Enable Jitsu btn
    can("view", "enable jitsu btn");

    //View Sentry error logging toggle in domain and page settings
    can("view", "sentry error logging");

    // View global alternative content
    can("view", "global alternative content");

    // View server-side cloaking
    can("view", "server-side cloaking");

    // View page ab test status in page form
    can("view", "page ab test status");

    // Can view microsoft auth button on login page
    can("view", "microsoft login button");

    // View settings workplace users
    can("view", "settings workplace users");

    // View domains list menu item
    can("view", "menu domains list");

    // View pages list menu item
    can("view", "menu pages list");

    // View ab tests list menu item
    can("view", "menu ab tests list");

    // View page elements menu item
    can("view", "menu page elements");

    // View help center menu item
    can("view", "menu help center");

    if (organizationRoles.includes(ROLE_OWNER.value) || organizationRoles.includes(ROLE_ADMIN.value)) {
      //View purchase domain
      can("view", "purchase domain");
    }
  }

  if (process.env.VUE_APP_INULTI_BUILD !== "true" && !organizationRoles.includes(ROLE_BASIC.value)) {
    //View Drip survey modal after registration
    can("view", "drip survey modal");

    //Use Drip tracking
    can("use", "drip tracking");

    //Use Google tag manager tracking
    can("use", "google tag manager");

    //View email verify disclaimer
    can("view", "email verify");

    //View cookie banner
    can("view", "cookie bar");

    //View free trial disclaimer
    can("view", "free trial disclaimer");

    //View register billing logout dropdown
    can("view", "billing logout");

    //Use 3rd party clarity script
    can("use", "3rd party clarity script");

    // Can view register button on login view
    can("view", "register button login page");

    // Can view google auth button on login page
    can("view", "google login button");

    // View settings workplace users
    can("view", "settings workplace users");

    // View domains list menu item
    can("view", "menu domains list");

    // View pages list menu item
    can("view", "menu pages list");

    // View ab tests list menu item
    can("view", "menu ab tests list");

    // View page elements menu item
    can("view", "menu page elements");

    // View help center menu item
    can("view", "menu help center");

    // External inulti organization only
    if (
      store.getters.getActiveOrganization?.organization?.id === "3e82fbb3-3b58-4414-8050-916ad443d64d" ||
      store.getters.getActiveOrganization?.organization?.id === "7af173a9-c379-4f0e-97a5-24a244669f00"
    ) {
      // Can login to airbyte
      can("view", "login to airbyte");
    }

    if (organizationRoles.includes(ROLE_OWNER.value)) {
      // Delete organization
      can("delete", "organization");
      // View delete account explanation
      can("view", "delete account explanation");
    }

    if (organizationRoles.includes(ROLE_OWNER.value) || organizationRoles.includes(ROLE_ADMIN.value)) {
      // View billing and payments information (tab)
      can("read", "billing and payments information");
    }
  }

  if (userRoles.includes(ROLE_SUPPORT.value)) {
    //View user impersonation
    can("view", "user view");
  }

  if (organizationRoles.includes(ROLE_BASIC.value)) {
    // View basic
    can("view", "basic user role");

    // View AI tools
    can("view", "ai_tools");

    // Can view menu items
    can("view", "settings");
  }

  return {
    build,
    rules,
  };
};

export default function defineAbilityFor() {
  const { build } = getAbilities();

  return build();
}

export const getRules = () => {
  const { rules } = getAbilities();

  return rules;
};
